// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__aEAn0","rotator":"styles_rotator__80Q2D","center-rotator":"styles_center-rotator__gdl2K","shimmer":"styles_shimmer__niLAQ"};